// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b1b38e91","901":"fdc3e4e2","946":"bd913fb1","991":"3fa6fa2f"}[chunkId] + ".chunk.js";
};